<template>
  <div style="height: calc(100vh - 195px);overflow: auto;">
    <div style="display: flex;justify-content: right;">
      <el-form :inline="true" class="form">
        <el-form-item :label="$t('failure.故障等级')+'：'" >
          <el-select :size="size" v-model="levelValue" filterable placeholder="请选择" style="width:140px">
            <el-option
              v-for="item in levelOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <quickQuery :isNow="true" @handleQuery="handleQuery" @quickQuery="quickQuery" @download="download" :downloading="downloading"/>
    </div>
    <div class="page_container">
      <el-table
        v-loading="loading"
        border
        :size="size" 
        :data="alarmlist"
        style="width: 100%;"
        tooltip-effect="light"
      >
        <el-table-column prop="id"  :label="$t('public.OrderIndex')" min-width="45" align="center"></el-table-column>
        <el-table-column prop="Group" :label="this.$t('failure.group')" min-width="100" align="center"></el-table-column>
        <el-table-column prop="CarNo" :label="$t('failure.carNo')" min-width="100" align="center"></el-table-column>
        <el-table-column prop="VehicleModel" :label="$t('failure.vehicleModel')" min-width="100" align="center" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="FailureTimec" :label="$t('failure.故障时间')" min-width="100" align="center" show-overflow-tooltip> </el-table-column>
        <el-table-column prop="Failrelevel" :label="$t('failure.故障等级')" min-width="80" align="center"></el-table-column>
        <el-table-column prop="FailureType" :label="$t('failure.故障类型')" min-width="80" align="center"></el-table-column>
        <el-table-column prop="Failure" :label="$t('failure.故障描述')" align="center" min-width="200" show-overflow-tooltip></el-table-column>
        <el-table-column :label="$t('failure.车辆位置')" min-width="85" align="center">
            <template slot-scope="scope">
              <div class="iconfont quickLinks"  @click="mapLacation(scope.row)"><i class="iconfont icon-icon_operat_map" :style="{color: !clickFlag(scope.row)? '#C0C4CC' :''}"></i></div>
            </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="text-align: right;margin-top:10px" class="pagination"  v-show="recordsTotal>0">  <!--  -->
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="pageSize"
        @size-change="handleSizeChange"
        layout="total, prev, pager, next, sizes"
        :total="recordsTotal">
      </el-pagination>
    </div>
    <div class="dialog">
      <el-dialog :title="$t('failure.车辆位置')" :visible.sync="mapShow">
        <div style="text-align:center">
          <KingLongMap mapId="klmap_failureDetail" ref="map" style="width:100%;height: 450px;" />
        </div>
        
      </el-dialog>
    </div>
  </div>
</template>
<script>
import quickQuery from "../../statistics/components/generalOrQuickQuery.vue"
import KingLongMap from "@/components/KingLongMap"
import { mapState } from 'vuex'
import language from '@/utils/getLanguageId'
export default {
  components: {
    quickQuery,
    KingLongMap,
  },
  props:{
    isDetail:{
      default:false,
      type:Boolean,
    }
  },
  data(){
    return{
      downloading:false,
      recordsTotal:0,
      pageSize:10,
      currentPage:1,
      mapShow:false,
      levelValue:0,
      levelOptions:[
        {value:0,label: this.$t("public.all")},
        {value:1,label: this.$t("failure.Rank1")},
        {value:2,label: this.$t("failure.Rank2")},
        {value:3,label: this.$t("failure.Rank3")},
      ],
      loading:false,
      alarmlist:[],
      form:undefined,
      vehicles:"",
      Latitude:0,
      Longitude:0,
      marker:undefined,
      label:undefined,
      LanguageId:1,
    }
  },
  computed:{
    size() {
      return this.$store.getters.size
    },
    ...mapState({
      selectedVehicles: state => state.app.vehicles.selectedVehicles,
    }),
  },
  watch:{
    isDetail(newval){
      if(newval){
        this.getData();
      }
    }
  },
  methods:{
    handleCurrentChange(page){
      this.currentPage = page;
      this.getData();
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getData();
    },
    clickFlag(row){
      if(row.Latitude==null||row.Longitude==null){
        return false;
      }
      else return true;
    },
    handleQuery(val){
      this.form = val;
      if(this.isDetail){
        this.currentPage = 1;
        this.getData();
      }
    },
    quickQuery(val){
      this.form = val;
      this.currentPage = 1;
      this.getData();
    },
    download(){
      this.vehicles = this.getSelectedVehicles();
      var that = this;
      that.downloading = true;
      this.$api
        .downloadFailureInfo({
          StartDate:this.form.beginDate,//initDate,//startTime,//"2023-09-17",//startTime,
          EndDate:this.form.endDate,//initDate,//endTime,//"2023-09-17",//endTime,
          vehicles:this.vehicles,
          OperatorID:this.$store.getters.operator.OperatorId,
          SubjectCorpID: this.$store.getters.operator.CompanyId,
          info:"",
          FailureLevel: this.levelValue == 0 ? undefined : this.levelValue,//查全部时不给这个参数
          IsExport: 1, // 0是查询 1是下载
          Language: this.LanguageId
        })
        .then((res)=>{
          let blob = new Blob([res], {
            type: "application/vnd.ms-excel;charset=utf-8",
          }); // 重点代码
          let a = document.createElement("a");
          a.href = window.URL.createObjectURL(blob);
          a.setAttribute(
            "download",
            that.$t('failure.故障等级') + ' ' + that.$t('public.download') + `_${that.timestampToTime(new Date().getTime())}.xlsx`
          ); // 表名，自定义
          a.click(); // 执行下载
          window.URL.revokeObjectURL(blob); // 释放ur
          that.downloading = false;
        }).catch((error) => {
          that.downloading = false;
            console.error("下载失败", error);
        });
    },
    //时间戳转换为日期格式
    timestampToTime(timestamp) {
      var date = new Date(timestamp); //时间数为10位篇*1000，时间数为13位的话不需乘1000
      var Y = date.getFullYear();
      var M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      var D = date.getDate();
      var h = date.getHours();
      var m = date.getMinutes();
      var s = date.getSeconds();
      return Y + M + D + h + m + s;
    },
    getSelectedVehicles(){
      this.vehicles = "";
      for(let k = 0; k < this.selectedVehicles.length; k++){
        if(this.selectedVehicles[k].treeLevel == 5){
          this.vehicles = this.vehicles + this.selectedVehicles[k].nodeValue + ",";
        }
      }
      return this.vehicles.substring(0,this.vehicles.length-1);
    },
    clickFlag(row){
      if(row.Latitude==null||row.Longitude==null){
        return false;
      }
      else return true;
    },
    //车辆位置
    mapLacation(row){
      this.mapShow = !this.clickFlag(row) ? false : true;
      // console.log(row);
      this.Latitude=row.Latitude;
      this.Longitude=row.Longitude;
      // console.log(this.Latitude,this.Longitude);
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.map) {
            this.$refs.map.clearMarkers();
            this.$refs.map.addMarker(
              "v_1011",
              row.CarNo,
              this.Longitude,
              this.Latitude,
              "assets/svgs/icon_loc_selected_270.svg"
            );
            this.$refs.map.setCenter(this.Longitude, this.Latitude);
          }
        }, 300)
      });
    },
    getData(){
      this.loading = true;
      // this.newTime =this.moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      this.vehicles = this.getSelectedVehicles();
        this.$api
          .FailureInfo({
            StartDate:this.form.beginDate,//initDate,//startTime,//"2023-09-17",//startTime,
            EndDate:this.form.endDate,//initDate,//endTime,//"2023-09-17",//endTime,
            vehicles:this.vehicles,
            OperatorID:this.$store.getters.operator.OperatorId,
            SubjectCorpID: this.$store.getters.operator.CompanyId,
            info:"",
            FailureLevel: this.levelValue == 0 ? undefined : this.levelValue,//查全部时不给这个参数
            pageNo:this.currentPage,
            pageSize:this.pageSize,
            IsExport: 0, // 0是查询 1是下载
            Language: this.LanguageId
          })
          .then((res)=>{
            if(res.recordsTotal > 0){
              this.alarmlist = res.data;
              this.recordsTotal=res.recordsTotal;
            
              this.loading = false;

            }
            else{
              this.loading = false;
              this.alarmlist=[];
               this.recordsTotal=res.recordsTotal;
              this.currentPage=1;
              
            }

          }).catch(() => {

              this.loading = false;
          });
      },
      
  },
  mounted() {
    this.LanguageId = language(this.$store.getters.locale)
    this.$nextTick(function () {
      // this.$refs.map.initMap();
      var myEvent = new Event("resize");
      window.dispatchEvent(myEvent);
    });
  },
}
</script>
<style lang="scss" scoped>
.form  {
  ::v-deep .el-form-item {
      margin-bottom: 0px !important;
  }

}
.dialog{
  ::v-deep .el-dialog__header{
    background: #E8F0FF;
    text-align: center;
  }
}
.pagination  {
  ::v-deep .el-pagination button:disabled,.el-pager li,.el-pagination .btn-prev, .el-pagination .btn-next{
    background-color: transparent !important;
  }

}
.quickLinks{
  font-size:12px;
  span{
    color:#2A7AFF;
    margin-right:20px;
    cursor: pointer;
  }
}
</style>